export const US_DATE_FORMAT = 'MMM do, yyyy';
export const DE_DATE_FORMAT = 'do MMMM yyyy';
export const ES_DATE_FORMAT = "do 'de' MMMM yyyy";
export const FR_DATE_FORMAT = 'd MMMM yyyy';

export const PRICE_VALID_UNTIL = '2030-01-01';
